import { Controller } from '@hotwired/stimulus';
import { expandCommentsInThread } from '@components/comments/comment_thread/component_controller';
import { updateReadMoreButtonVisibility } from '@components/comments/comment/component_controller';
import { reload as reloadLazyPartial } from '@controllers/main/lazy-partial_controller';
import { displayReset, hide, runWhenDomLoaded } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'commentThreadsContainer',
    'showAllCommentThreadsButton',
    'comment',
    'lazyPartial',
  ];

  connect() {
    runWhenDomLoaded(this.handleDocumentLoaded.bind(this));
  }

  reload(_event) {
    if (this.hasShowAllCommentThreadsButtonTarget) {
      this.showAllCommentThreads();
    }

    reloadLazyPartial(this.lazyPartialTarget);
  }

  handleDocumentLoaded() {
    const commentIdHashRegexp = /#comment-(\d+)/;
    const result = window.location.hash.match(commentIdHashRegexp);
    if (result) {
      const commentId = parseInt(result[1]);
      this.scrollToCommentById(commentId);
    }
  }

  showAllCommentThreads() {
    hide(this.showAllCommentThreadsButtonTarget);
    displayReset(this.commentThreadsContainerTarget);
    this.commentTargets.forEach((target) =>
      updateReadMoreButtonVisibility(target)
    );
  }

  scrollToComment(event) {
    this.scrollToCommentById(event.params.id);
  }

  scrollToCommentById(id) {
    if (this.hasShowAllCommentThreadsButtonTarget) {
      this.showAllCommentThreads();
    }

    const commentId = `#comment-${id}`;
    const commentElement = this.element.querySelector(commentId);
    expandCommentsInThread(commentElement);

    // NB: The scroll event is called more often than every 100ms, so whenever
    // scrolling ended, the event handler will be cleared.
    let scrollTimeout;
    window.addEventListener('scroll', function callback() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        window.location.hash = commentId;
        window.removeEventListener('scroll', callback);
      }, 100);
    });

    commentElement.scrollIntoView({ behavior: 'instant', block: 'start' });
  }
}
